import type { WaveConfig } from "./_type";
import type { ThemeConfig } from "antd";

export const theme = {
  cssVar: true,
  token: {
    borderRadius: 4,
    colorBorder: "#ccc",
    colorText: "#000",
    fontSize: 13,
    padding: 12,
    colorPrimary: "#cf122e",
  },
  components: {
    Tree: {
      nodeHoverBg: "transparent",
    },
    Menu: {
      iconSize: 16,
      itemMarginInline: 6,
    },
    Layout: {
      zeroTriggerWidth: 40,
      headerBg: "transparent",
      footerPadding: "12px 50px",
      headerHeight: 48,
    },
    Pagination: {
      borderRadius: 2,
    },
    Segmented: {
      itemSelectedColor: "var(--primary-6)",
    },
    Typography: {
      titleMarginTop: 0,
      titleMarginBottom: 0,
    },
    Steps: {
      customIconTop: -2,
    },
    Breadcrumb: {
      lastItemColor: "rgba(0,0,0,0.45)",
    },
    Spin: {
      contentHeight: "100%",
    },
    Table: {
      cellFontSizeSM: 12,
    },
    Tour: {
      zIndexBase: 9999,
    },
    Avatar: {
      textFontSizeSM: 11,
      containerSizeSM: 20,
    },
    Card: {
      headerPaddingSM: 12,
    },
  },
} satisfies ThemeConfig;

// Inset Effect
export const showInsetEffect: WaveConfig["showEffect"] = (
  node,
  { event, component }
) => {
  // Prepare effect holder
  const createHolder = (node: HTMLElement) => {
    const { borderWidth } = getComputedStyle(node);
    const borderWidthNum = parseInt(borderWidth, 10);

    const div = document.createElement("div");
    div.style.position = "absolute";
    div.style.inset = `-${borderWidthNum}px`;
    div.style.borderRadius = "inherit";
    div.style.background = "transparent";
    div.style.zIndex = "999";
    div.style.pointerEvents = "none";
    div.style.overflow = "hidden";
    node.appendChild(div);

    return div;
  };

  const createDot = (
    holder: HTMLElement,
    color: string,
    left: number,
    top: number,
    size = 0
  ) => {
    const dot = document.createElement("div");
    dot.style.position = "absolute";
    dot.style.left = `${left}px`;
    dot.style.top = `${top}px`;
    dot.style.width = `${size}px`;
    dot.style.height = `${size}px`;
    dot.style.borderRadius = "50%";
    dot.style.background = color;
    dot.style.transform = "translate(-50%, -50%)";
    dot.style.transition = "all 1s ease-out";
    holder.appendChild(dot);

    return dot;
  };

  if (component !== "Button") {
    return;
  }

  const holder = createHolder(node);

  const rect = holder.getBoundingClientRect();

  const left = event.clientX - rect.left;
  const top = event.clientY - rect.top;

  const dot = createDot(holder, "rgba(255, 255, 255, 0.65)", left, top);

  // Motion
  requestAnimationFrame(() => {
    dot.ontransitionend = () => {
      holder.remove();
    };

    dot.style.width = "200px";
    dot.style.height = "200px";
    dot.style.opacity = "0";
  });
};

export const wave = {
  showEffect: showInsetEffect,
} satisfies WaveConfig;
